import { useWsmDealerGroupListQuery } from "@dashboard/graphql";
import useLocalPaginator, { useLocalPaginationState } from "@dashboard/hooks/useLocalPaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React, { useState } from "react";

import WsmDealerGroupListPage from "../components/WsmDealerGroupListPage/WsmDealerGroupListPage";

const PAGINATE_BY = 20;

export const WsmDealerGroupListView = () => {
  const [query, setQuery] = useState("");
  const [rowNumber, setRowNumber] = useState(PAGINATE_BY);
  const [paginationState, setPaginationState] = useLocalPaginationState(rowNumber);
  const paginate = useLocalPaginator(setPaginationState);
  const { data, loading } = useWsmDealerGroupListQuery({
    variables: {
      ...paginationState,
      filter: query ? { search: query } : {},
    },
  });
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    data?.wsmDealerGroups?.pageInfo,
    paginationState,
  );

  return (
    <WsmDealerGroupListPage
      groups={loading ? undefined : (mapEdgesToItems(data?.wsmDealerGroups) ?? [])}
      query={query}
      settings={{ rowNumber }}
      hasNextPage={pageInfo?.hasNextPage ?? false}
      hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      onQueryChange={value => {
        setQuery(value);
        setPaginationState({});
      }}
      onUpdateListSettings={(_key, value) => setRowNumber(Number(value))}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
    />
  );
};

export default WsmDealerGroupListView;
